<div
  class="h-[80vh] w-[80vw] scale-125 origin-top-left overflow-hidden flex justify-center items-center bg-cover bg-center bg-no-repeat bg-[length:120%] bg-[#FFFFFF]"
  style="background-image: url('assets/images/login-image.png');">

  <div class="bg-white/90 px-12 pt-12 pb-12 rounded-lg shadow-lg w-full max-w-[32rem] mx-4">
    <div class="flex justify-center mb-5 scale-125">
      <img src="assets/images/logo-black.svg" alt="Logo" class="h-15">
    </div>
    <p class="text-center text-gray-600 text-base font-normal leading-4 font-['Inter'] mb-4">Enter your credentials to
      access the platform</p>

    <div id="alert-message" class="mb-4">
      <app-alert-message type="error" *ngIf="showError()">
        <p class="text-gray-800 text-base font-normal leading-4 font-['Inter'] pb-3">Authentication Failed</p>
        <p class="text-gray-600 text-sm font-normal leading-normal font-['Inter']">The username or password you entered
          is incorrect. </p>
        <p class="text-gray-600 text-sm font-normal leading-normal font-['Inter']">Please try again. </p>
      </app-alert-message>
    </div>

    <app-spinner [isLoading]="isLoading()"></app-spinner>

    <form (ngSubmit)="onLogin()" class="space-y-4" [formGroup]="loginForm">
      <div>
        <label for="login-username-field"
          class="block text-gray-700 text-sm font-normal font-['Inter'] mb-1">Username</label>
        <input type="text" id="login-username-field" formControlName="username" required
          placeholder="Enter your username"
          class="w-full h-[50px] px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-0 focus:border-gray-300 bg-transparent [&:-webkit-autofill]:bg-transparent [&:-webkit-autofill]:!bg-transparent placeholder:text-[#ADAEBC] placeholder:font-['Inter'] placeholder:text-base placeholder:font-normal placeholder:leading-6">
      </div>

      <div>
        <label for="login-password-field"
          class="block text-gray-700 text-sm font-normal font-['Inter'] mb-1">Password</label>
        <input type="password" id="login-password-field" formControlName="password" required
          placeholder="Enter your password"
          class="w-full h-[50px] px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-0 focus:border-gray-300 bg-transparent [&:-webkit-autofill]:bg-transparent [&:-webkit-autofill]:!bg-transparent mb-2 placeholder:text-[#ADAEBC] placeholder:font-['Inter'] placeholder:text-base placeholder:font-normal placeholder:leading-6">
      </div>

      <div>
        <button type="submit" id="login-submit-button"
          class="w-full h-12 bg-gray-800 text-white py-2 px-4 rounded-md hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200 cursor-pointer">
          Log In
        </button>
      </div>

      <div class="text-center">
        <a id="login-forgot-password-link" [href]="forgotPasswordUrl" target="_blank" rel="noopener noreferrer"
          class="text-gray-700 text-sm font-normal font-['Inter'] leading-[14px] cursor-pointer">
          Forgot your password?
        </a>
      </div>

      <div class="mt-4">
        <hr class="border-t border-gray-200 mb-2">
        <div class="text-center">
          <span class="block text-gray-500 text-sm font-normal font-['Inter'] mb-1">
            Need help? Contact AMS Support:
          </span>
          <a id="login-email-support-link" href="mailto:AgencySupport@wfgnationaltitle.com"
            class="block text-gray-800 text-base font-normal font-['Inter'] font-bold hover:underline cursor-pointer">
            AgencySupport&#64;wfgnationaltitle.com
          </a>
        </div>
      </div>
    </form>
  </div>
</div>